import React from "react";

import {
  P,
  SectionHeading,
  SectionSmallHeading,
  SectionSubHeading,
  SectionWrapper,
} from "../../../styles";
import Menu from "./menu";
import styled from "@emotion/styled";
import { Container, Grid } from "@mui/material";
const TwoButtons = styled.div``;
const BuyButton = styled.button`
  cursor: pointer;
  padding: 9px 35px;
  border: none;
  font-weight: 600;
  font-size: 14px;
  border: ${(props) => (props.brdrColor ? props.brdrColor : "1px solid #fff")};
  max-width: 100%;
  background-color: ${(props) => (props.bgColor ? props.bgColor : "#243D44")};
`;
const VideoBK = styled.video`
  /* width: 100%;
  height: auto;
  display: block; */
  object-fit: cover;
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: -1;
`;
const Span = styled.span`
  font-size: 50px;
  color: #0d7757;
  @media screen and (max-width: 599px) {
    font-size: 30px;
  }
`;
const Index = () => {
  return (
    <div>
      <VideoBK autoPlay loop muted>
        <source src="/images/Kirin.mp4" type="video/mp4" />
      </VideoBK>
      <Menu />
      <SectionWrapper pt="0px" id="explore" pb650px="10px">
        <Container maxWidth="xl">
          <Grid container>
            <Grid xs={12}>
              <SectionHeading m=" 15px 0">
                Kirin<Span>麒麟</Span>{" "}
              </SectionHeading>
              <P maxWidth="40%">
                The Great Kirin has arrived to bring equilibrium to the degens
                of crypto and serve justice to those who have created chaos and
                disorder to the crypto space. Either you are with us, or you are
                against us. We are Kirin.
              </P>
              <TwoButtons>
                <a
                  href="https://app.uniswap.org/#/swap?outputCurrency=0x2ac99c198d9b65dbb076a37518bed31d480a0567&chain=mainnet"
                  target="blank"
                >
                  <BuyButton brdrColor="none">Buy Now</BuyButton>
                </a>
                &nbsp;&nbsp;&nbsp;
                <a
                  href="https://www.dextools.io/app/ether/pair-explorer/0x9144b6aa44d6df5cc9868533e6cd7345fa0e078d"
                  target="blank"
                >
                  <BuyButton bs="none" bgColor=" rgba(13, 119, 87, 0.15)">
                    Live Chart
                  </BuyButton>
                </a>
              </TwoButtons>
            </Grid>
          </Grid>
        </Container>
      </SectionWrapper>
    </div>
  );
};

export default Index;
